import React from 'react';
import strings from './strings.js'
//{song.id.videoId.substring(0, 20)}
const API_URL = "https://starboxkod.com/api";

const YtCard = ({ song, onClick, innerRef, lang } ) => {
    return (
        <div className="song-panel" onClick={onClick} ref={innerRef}>
            <img className="song-panelPhoto"
                    src={`${song.snippet.thumbnails.default.url}`}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src="https://via.placeholder.com/100";
                    }}
                    alt={song.song_name}/>
            <div className="song-panelText">
                <div className="song-panelSongcode"></div>
                <div className="song-panelLanguage">YouTube</div>
                <div dangerouslySetInnerHTML={{__html: song.snippet.title.substring(0, 20)}} className="song-panelName"></div>
                <div className="song-panelArtists">
                    <div className="song-panelArtist">
                        {song.snippet.channelTitle.substring(0, 20)}
                    </div>
                </div>
            </div>   
        </div>
    );
}

export default YtCard;